import { render, staticRenderFns } from "./NotificationDetail.vue?vue&type=template&id=35bd56b7&scoped=true&lang=pug"
import script from "./NotificationDetail.vue?vue&type=script&lang=ts"
export * from "./NotificationDetail.vue?vue&type=script&lang=ts"
import style0 from "./NotificationDetail.vue?vue&type=style&index=0&id=35bd56b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bd56b7",
  null
  
)

export default component.exports